/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRechercheClasseHoraireRemplacementOccasionnelDto } from './FcbRechercheClasseHoraireRemplacementOccasionnelDto';
import {
    FcbRechercheClasseHoraireRemplacementOccasionnelDtoFromJSON,
    FcbRechercheClasseHoraireRemplacementOccasionnelDtoFromJSONTyped,
    FcbRechercheClasseHoraireRemplacementOccasionnelDtoToJSON,
} from './FcbRechercheClasseHoraireRemplacementOccasionnelDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResults
 */
export interface FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRechercheClasseHoraireRemplacementOccasionnelDto>}
     * @memberof FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResults
     */
    results?: Array<FcbRechercheClasseHoraireRemplacementOccasionnelDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResults interface.
 */
export function instanceOfFcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResultsFromJSON(json: any): FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResults {
    return FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRechercheClasseHoraireRemplacementOccasionnelDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResultsToJSON(value?: FcbRechercheClasseHoraireRemplacementOccasionnelDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRechercheClasseHoraireRemplacementOccasionnelDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

